import { SetupTemplates } from 'components'
import Helmet from 'react-helmet'

import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions } from 'actions'
import { SEOSettingsStore } from 'stores'
import Enum from 'utils/Enum'
import { APP_NAME } from 'consts'

const routesSequence = ['/charge/success', '/setup/home', '/setup/title', '/setup/description', '/plus/manage?autoInstall=true']

@connectToStores
export default class OnboardingTemplatesContainer extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  }

  static propTypes = {
    params: React.PropTypes.object.isRequired,
  }

  static getStores() {
    return [SEOSettingsStore]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState()
    }
  }

  constructor(props) {
    super(props)

    if (!props.settings) {
      SEOSettingsActions.fetch()
    }

    const key = props.params.key.toLowerCase()
    this.state = this.routeState(key)
  }

  componentWillUpdate(nextProps) {
    if (this.props.params.key !== nextProps.params.key) {
      this.setState(this.routeState(nextProps.params.key.toLowerCase()))
    }
  }

  routeState(key) {
    const routeIndex = routesSequence.indexOf(`/setup/${key}`)

    return {
      key,
      prevRoute: routesSequence[routeIndex - 1],
      nextRoute: routesSequence[routeIndex + 1],
    }
  }

  saveAndContinue(variables) {
    const keyTemplateMap = Enum.OnboardingTemplateGenerate(variables)

    SEOSettingsActions.update(keyTemplateMap)
    this.context.router.push(this.state.nextRoute)
  }

  render() {
    const { key, prevRoute, nextRoute } = this.state

    return (
      <div>
        <div className="setup-logo-container">
          <img className="setup-brand-symbol" alt="Plug in Useful" src="../../assets/images/brand-symbol.png" />
          <img className="setup-logo" alt={APP_NAME} src="../../assets/images/logo-color.png" />
        </div>
        <Helmet title='Plug in SEO - Setup Templates' />
        <div className="onboardingTemplates">
          <SetupTemplates
            title={Enum.OnboardingTitles[key]}
            checklist={Enum.OnboardingChecklists[key]}
            variables={Enum.OnboardingVariables[key]}
            onSave={values => this.saveAndContinue(values)}
            prevRoute={prevRoute}
            nextRoute={nextRoute}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/OnboardingTemplatesContainer.js